import React, { useState } from "react";
import { Box, Grid, FormControl } from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { completarRequisito } from "../services/expediente.service";
import CustomTextarea from "./CustomTextarea";

export default function RequisitoRespuestaTexto({
  setIsVisibleModal,
  setReload,
  reload,
  requisito,
}) {
  const [message, setMessage] = useState(requisito.mov_respuesta_obs || "");

  const handleInputChangeMessage = (event) => {
    const value = event.target ? event.target.value : event;
    setMessage(value);
  };

  const completarRequisitoConRespuesta = async () => {
    try {
      const data = {
        id_mov: requisito.id_mov,
        mov_respuesta_obs: message,
      };
      const result = await completarRequisito(data);

      if (result.data) {
        setReload(!reload);
        onClose();
      }
    } catch (error) {
      console.log("Failed to add selection", error);
    }
  };

  const onClose = () => {
    setMessage("");
    setIsVisibleModal(false);
  };

  return (
    <>
      <Grid item xs={12}>
        <FormControl fullWidth variant="outlined" size="small">
          <CustomTextarea
              rows={4}
              value={message}
              onChange={handleInputChangeMessage}
              label="Observación"
            />
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Box display="flex" justifyContent="space-between">
          <ButtonComponent
            name="Guardar"
            toAction={completarRequisitoConRespuesta}
            disabled={!message}
          />
          <div style={{ width: "5px" }}></div>
          <ButtonComponent
            name="Cancelar"
            toAction={onClose}
            color={COLORS.DANGER}
          />
        </Box>
      </Grid>
    </>
  );
}
